import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";
import type { ReactNode } from "react";

// Shared event header component for consistent layout
interface EventHeaderProps {
  title: string;
  meta?: ReactNode;
  className?: string;
}

export function EventHeader({ title, meta, className }: EventHeaderProps) {
  return (
    <div
      className={`flex flex-1 items-center justify-between ${className || ""}`}
    >
      <div className="flex items-center gap-2">
        <span className="font-medium">{title}</span>
      </div>
      <div className="flex items-center gap-2">{meta}</div>
    </div>
  );
}

// Standardized info tooltip component
interface EventTooltipProps {
  content: string;
  icon?: ReactNode;
}

export function EventTooltip({ content, icon }: EventTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger>
        {icon || <Info className="h-3 w-3 text-muted-foreground/80" />}
      </TooltipTrigger>
      <TooltipContent>
        <div className="max-w-64 text-xs">{content}</div>
      </TooltipContent>
    </Tooltip>
  );
}

// Helper for creating badge components
export function createEventBadge(
  text: string,
  variant: "outline" | "destructive" | "secondary" = "outline",
  className?: string,
) {
  return (
    <Badge variant={variant} className={`text-xs ${className || ""}`}>
      {text}
    </Badge>
  );
}
